export default "__VITE_ASSET__C0X8djx$__"